import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async getAll() {
        const res = await http.get(buildUrlFromLocation(`/admin/standDesigns/list`));
        return res.data;
    }
};



// WEBPACK FOOTER //
// ./src/services/stand-design.js